// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Record, RecordLinkValue, FormValues } from '@fulcrumapp/fulcrum-core';
import Button from '../../shared/button';
import RecordLinkPickerItem from './record-link-picker-item';
import RecordLinkQuery from '../../utils/record-link-query';
import { AppContext } from '../../hooks/use-app';
import { cssInJS } from '../../utils/styles';

const PAGE_SIZE = 40;

export default class RecordLinkPicker extends React.Component {
  static propTypes = {
    record: PropTypes.instanceOf(Record).isRequired,
    value: PropTypes.instanceOf(RecordLinkValue).isRequired,
    valuesForPredicate: PropTypes.instanceOf(FormValues).isRequired,
    // viewOnlyMode: PropTypes.bool.isRequired,
    onCloseClick: PropTypes.func.isRequired,
    onRecordClick: PropTypes.func.isRequired,
  };

  static contextType = AppContext;

  constructor(props, context) {
    super(props, context);

    this.state = {
      count: null,
      offset: null,
      results: [],
      isInfiniteLoading: false,
      search: null,
    };
  }

  componentDidMount() {
    if (this.state.count == null) {
      this.handleInfiniteLoad();
    }
  }

  render() {
    const { styles } = RecordLinkPicker;

    return (
      <div className={styles.container}>
        <div className={styles.header}>
          Select a Record
        </div>
        <div className={styles.toolbar}>
          <input
            type="text"
            className={styles.search}
            placeholder="Search"
            onChange={this.handleSearchChange}
          />
        </div>
        <div className={css(styles.records)}>
          {this.renderInfiniteList()}
        </div>
        <Button
          text
          key="close"
          className={css(styles.close)}
          onClick={this.props.onCloseClick}
        >
          Close
        </Button>
      </div>
    );
  }

  renderInfiniteList() {
    const { styles } = RecordLinkPicker;

    if (this.hasNoRecords) {
      return (
        <div className={css(styles.empty)}>
          No records
        </div>
      );
    }

    return (
      <InfiniteScroll
        height={260}
        dataLength={this.state.results.length}
        next={this.handleInfiniteLoad}
        hasMore={this.hasMoreRecords}
        loader={this.renderSpinner()}
      >
        {this.renderRecords()}
      </InfiniteScroll>
    );
  }

  renderRecords() {
    return this.state.results.map((item, index) => (
      <RecordLinkPickerItem
        key={index}
        record={item}
        onClick={this.props.onRecordClick}
      />
    ));
  }

  renderSpinner() {
    if (!this.state.isInfiniteLoading) {
      return null;
    }

    const { styles } = RecordLinkPicker;

    return <div className={css(styles.loading)}>Loading...</div>;
  }

  handleInfiniteLoad = () => {
    if (this.hasMoreRecords) {
      this.fetchRecords();
    }
  };

  fetchRecords() {
    this.setState({ isInfiniteLoading: true }, () => {
      const offset = this.state.offset || 0;
      const pageNumber = Math.floor(offset / PAGE_SIZE) + 1;

      const params = {
        per_page: PAGE_SIZE,
        page: pageNumber,
      };

      if (this.state.search) {
        params.search = this.state.search;
      }

      const query = new RecordLinkQuery(this.props.value.element,
        this.props.record,
        this.props.valuesForPredicate,
        this.context.role);

      params.where = query.where;

      params.order = this.props.value.element.form.titleFieldKeys.map((key) => {
        const titleElement = this.props.value.element.form.get(key);
        if (['Label', 'Section'].includes(titleElement.type)) {
          return [];
        }
        return [key, 'asc'];
      }).filter((entry) => entry.length === 2);

      this.context.dataSource.queryRecords(this.props.value.element.form, params, (err, objects, totalCount) => {
        if (err) {
          throw err;
        }

        const newState = {
          isInfiniteLoading: false,
          count: totalCount,
          results: this.state.results.concat(objects),
          offset: offset + objects.length,
        };

        this.setState(newState);
      });
    });
  }

  get hasMoreRecords() {
    return this.state.count == null || this.state.offset == null || this.state.offset < this.state.count;
  }

  get hasNoRecords() {
    return !this.hasMoreRecords && this.state.count === 0;
  }

  handleSearchChange = (event) => {
    const DELAY = 300;

    clearTimeout(this._searchTimeout);

    const search = event.target.value.length > 0 ? event.target.value : null;

    this._searchTimeout = setTimeout(() => {
      this.setState({
        count: null, offset: null, results: [], search,
      }, () => {
        this.fetchRecords();
      });
    }, DELAY);
  };
}

const styles = cssInJS({
  container: {
    padding: 30,
    backgroundColor: '#fff',
    height: '100%',
  },

  header: {
    fontWeight: 'bold',
    paddingBottom: 10,
  },

  search: {
    borderRadius: 5,
    width: '100%',
    border: '1px solid #d9d9d9',
    padding: 8,
    fontSize: 13,
  },

  records: {
    height: 260,
    marginTop: 8,
  },

  close: {
    marginTop: 20,
    marginBottom: 20,
    float: 'right',
  },

  empty: {
    padding: 6,
    color: '#aaa',
  },

  loading: {
    padding: 6,
    fontStyle: 'italic',
  },
});

RecordLinkPicker.styles = styles;
